import React, {useEffect, useState} from 'react';

import { ClipboardCopyIcon, DocumentTextIcon, FireIcon } from '@heroicons/react/outline'

const OrganizationStats = ({allMsgOrg, copiedOrg, likedOrg}) => {

    const [ allProjects, setAllProjects ] = useState()

    useEffect(() => {
        const countProjects = () => {
            var arr = [];
            allMsgOrg?.map(projects =>{
                if(projects.ContentCreated){
                    projects.ContentCreated.map(project => {
                        return arr.push(project)
                    })
                    return projects
                }else { 
                    return null
                }
            })
            setAllProjects(arr)
        }

        countProjects()
    }, [allMsgOrg])

    var all = allProjects ? allProjects?.length : 0;
    var copied = (allProjects && copiedOrg) ? ((copiedOrg?.length / allProjects?.length) * 100) : 0
    var liked = (allProjects && likedOrg) ? ((likedOrg?.length / allProjects?.length) * 100) : 0

    const stats = [
        { name: 'Total Messages', stat:  all, icon: DocumentTextIcon,},
        { name: 'Total Copied', stat:  copied.toFixed(2) === 'NaN' ? (0 + ' %') : copied.toFixed(2) + ' %', icon: ClipboardCopyIcon, length: copiedOrg?.length},
        { name: 'Total Fire', stat: liked.toFixed(2) === 'NaN' ? (0 + ' %') : liked.toFixed(2) + ' %',  icon: FireIcon, length: likedOrg?.length},
    ]

    return (
        <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">All Time Team Messages Created</h3>
            <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {stats.map((item) => (
                <div
                key={item.name}
                className="relative bg-white pt-5 px-4 pb-4 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden"
                >
                <dt>
                    <div className="absolute bg-indigo-500 rounded-md p-3">
                    <item.icon className="h-6 w-6 text-white" aria-hidden="true" />
                    </div>
                    <p className="ml-16 text-sm font-medium text-gray-500 truncate">{item.name}</p>
                </dt>
                <dd className="ml-16 flex items-baseline ">
                    <p className="text-2xl font-semibold text-gray-900">{item.stat}</p>
                </dd>
                {item.length > 0 ?
                <div className="font-medium text-gray-600 text-right my-2">
                    Amount: {item.length}
                </div>
                :
                null }
                </div>
            ))}
            </dl>
        </div>
    )
}

export default OrganizationStats